import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getMarkAsPaidPayments } from 'modules/_common/api';

export const useQueryMarkAsPaidInvoice = ({
  invoiceId,
  enabled,
}: {
  invoiceId: string;
  enabled: boolean;
}) => {
  return useQuery(
    [QUERY_KEYS.INVOICES_MARK_AS_PAID_INVOICE, invoiceId],
    () => getMarkAsPaidPayments(invoiceId),
    {
      enabled,
    },
  );
};
